import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getViewInfo } from '@americanexpress/data-manager-utils';
import { useDDL } from '@americanexpress/react-ddl';
import PropTypes from 'prop-types';

export const UpdateViewDdl = ({ updateViewData, locale }) => {
  const { updateDDL } = useDDL();
  useEffect(() => {
    if (updateViewData) {
      updateDDL({
        name: 'view',
        value: {
          ...getViewInfo(),
          ...{
            country: locale.split('-')[1],
            language: locale.split('-')[0],
            locale,
            ...updateViewData,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateViewData]);
  return null;
};

UpdateViewDdl.propTypes = {
  locale: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  updateViewData: PropTypes.object,
};

export const mapStateToProps = (state) => ({
  updateViewData: state.getIn(['modules', 'axp-card-member-apply-root', 'query', 'updateViewData']),
});

const UpdateViewDDL = UpdateViewDdl;
export default connect(mapStateToProps)(UpdateViewDDL);
